import { createSlice } from '@reduxjs/toolkit'
import { odinApi } from 'services/api'

const initialState = {
  odinFileList: {},
  isListLoading: false,
  error: null
}

const odinSlice = createSlice({
  name: 'odin',
  initialState,
  reducers: {
    getFileListStart (state) {
      state.error = null
      state.isListLoading = true
    },
    getFileListSuccess (state, { payload }) {
      state.odinFileList = payload
      state.error = null
      state.isListLoading = false
    },
    getFileListFailed (state, { payload }) {
      state.odinFileList = {}
      state.error = payload.customError
      state.isListLoading = false
    },
    clear (state) {
      state.odinFileList = {}
      state.error = null
    }
  }
})

const {
  getFileListStart,
  getFileListSuccess,
  getFileListFailed,
  clear
} = odinSlice.actions

const getFileList = () => async (dispatch) => {
  try {
    dispatch(getFileListStart())
    const logList = await odinApi.getFileList()
    dispatch(getFileListSuccess(logList))
  } catch (error) {
    dispatch(getFileListFailed({ error }))
  }
}

export { getFileList, clear }

export default odinSlice.reducer
